import { SessionDataItem } from '../models/dashboardTypes';

export const MAX_FILES = 9;

export interface SessionTableRow {
  field: string;
  [key: string]: string;
}

export const createUploadStatusRow = (sessions: SessionDataItem[]): SessionTableRow => {
  const uploadRow: SessionTableRow = { field: 'Upload Status' };

  sessions.forEach((session) => {
    const sessionKey = session.sessionNumber;
    if (!sessionKey) return;

    const uploadCount = session.recordingUploadCount;
    uploadRow[sessionKey] =
      uploadCount !== undefined && uploadCount !== null ? `${uploadCount}/${MAX_FILES}` : `?/${MAX_FILES}`;
  });

  return uploadRow;
};
